import { createSlice } from '@reduxjs/toolkit';
export const Loading = createSlice({
  name: 'dropdown',
  initialState: {
    loading: false,
  },
  reducers: {
    setloading: (state, action) => {
      state.loading = action.payload;
    },
  },
});
export const SetLoading = () => async (dispatch) => {
  return dispatch(setloading(true));
};

export const ClearLoading = () => async (dispatch) => {
  return dispatch(setloading(false));
};

export const { setloading } = Loading.actions;
export default Loading.reducer;
